import { PageContentStateContext } from '@src/contexts/wysiwyg/page_content';
import { useContext } from 'react';

function usePageContentItemStackOrder(contentItemId: string) {
  const { contentItems } = useContext(PageContentStateContext);
  return contentItems.findIndex((item) => item.id === contentItemId) + 1;
}

export default usePageContentItemStackOrder;
